// @flow
import React, { Component } from 'react';
import BannerCardList from 'components/common/BannerCardList/BannerCardList';
import type { State } from 'store';
import { BanneringActions } from 'store/actionCreators';
import type { BannerItem } from 'store/modules/bannering';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type Props = {
  banners: ?(BannerItem[]),
  prefetched: ?(BannerItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class TrendingBannerCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { banners, prefetching, loading } = this.props;
    if (!banners || banners.length === 0 || prefetching || loading) return;
    const lastId = banners[banners.length - 1].id;
    if (this.props.prefetched) {
      BanneringActions.revealPrefetched('trending');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await BanneringActions.prefetchTrendingBanners(
        (this.props.banners && this.props.banners.length) || 0,
      );
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    // this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { shouldCancel, banners } = this.props;
    if (banners && banners.length > 0) {
      // do not fetch banner data when already exists
      return;
    }
    try {
      if (!shouldCancel) {
        await BanneringActions.getTrendingBanners();
      }
      // this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  componentDidMount() {
    this.initialize();
    // this.listenScroll();
  }

  componentWillUnmount() {
    // this.unlistenScroll();
  }

  render() {
    return (
      <BannerCardList
        banners={this.props.banners}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        isTrending
      />
    );
  }
}

const mapStateToProps = ({ bannering, pender, base, common }: State) => ({
  banners: bannering.trending.banners,
  prefetched: bannering.trending.prefetched,
  prefetching: pender.pending['bannering/PREFETCH_TRENDING_BANNERS'],
  loading: pender.pending['bannering/GET_TRENDING_BANNERS'],
  width: base.windowWidth,
  hasEnded: bannering.trending.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(TrendingBannerCards);



// WEBPACK FOOTER //
// ./src/containers/list/TrendingBannerCards.js